<template>
<svg viewBox="0 0 130 130" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-psm-zxhuihua-fil`]" width="1em" height="1em" v-bind="$attrs"><g fill="none" fill-rule="evenodd"><path d="M13.7259311,34.6992182 L29.0395198,25.389794 C32.5978647,23.2366485 32.5978647,19.8164467 29.0395198,17.6633012 L13.7259311,8.35403161 C10.1674311,6.20088615 7.43502802,7.84720906 7.43502802,11.9003979 L7.43502802,31.2162434 C7.37142243,35.2694322 10.2304161,36.7889722 13.7259311,34.6992182 Z M17.6018386,40.968944 C9.21427804,46.0983964 0,41.0323355 0,31.1528519 L0,11.8370065 C0,2.02091432 9.15051732,-3.10853807 17.6018386,2.02091432 L32.8524422,11.3308024 C41.0491859,16.3334718 41.0491859,26.6563865 32.8524422,31.6595198 C32.7888366,31.6595198 17.6018386,40.968944 17.6018386,40.968944 Z" transform="translate(46 37)" :fill="useCurrentColor ? 'currentColor' : '#1BA8AF'"/><rect stroke="#1BA8AF" stroke-width="10" x="11" y="16" width="108" height="80" rx="9"/><rect :fill="useCurrentColor ? 'currentColor' : '#1BA8AF'" x="17" y="108" width="98" height="10" rx="5"/></g></svg>
</template>
<script>

export default {
  name: 'IconPsmZxhuihuaFil',
  props: {
    prefix: {
        type: String,
        default: 'psm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
